import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { CalendarDays, Cross, X } from "lucide-react";
import cash from "../../assets/images/svgs/other/cashHand.svg";

const Paydetail = ({ open, onClose, card, currencySymbol }) => {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] grid place-items-center p-8 md:p-0">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal Box */}
      <div className="relative z-10 w-full max-w-md mx-4 rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex justify-between">
          <div>
            <h1 className="text-center font-medium text-base text-black">
              Payment Details
            </h1>
          </div>
          <div>
            <X size={15} className="cursor-pointer" onClick={onClose} />
          </div>
        </div>

        <div className="border-b border-gray-100 my-3" />

        <p className="text-base font-bold text-center text-[#FF6943]">
          Amount Received : {currencySymbol}{" "}
          {Number(card.amount || card.total_amount).toFixed(2)}
        </p>

        <div className="border-b border-gray-100 my-3" />

        <p className="flex items-center justify-center gap-2 text-sm text-[#606060]">
          <CalendarDays size={18} />
          {card.date_time || card.order_date}
        </p>

        <div className="border-b border-gray-100 my-3" />

        <div className="flex gap-2 justify-center items-center">
          <img src={cash} alt="cash" className="h-4 w-4" />
          <span className="text-[#191919]">
            {" "}
            {card?.latest_payment?.payment_type || card?.payment_type}
          </span>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Paydetail;
